import React, { useEffect, useState } from 'react'
import { graphql } from 'react-apollo';
import { FormattedMessage } from 'react-intl';
import { Modal, ModalBody } from 'reactstrap';
import createProviderMutation from './mutation';
import "./styles/CreateProviderModal.scss";

const CreateProviderModal = ({ 
  showCreateProviderModal, 
  handlerCreateProvider, 
  createProvider,
  providerName,
  refetch,
  updateField,
  fieldName,
}) => {
  const [providerByUser, setProviderByUser] = useState(providerName);
  const [errorMessage, setErrorMessage] = useState(false);

  const createNewProvider = (e) => {
    return createProvider({
      variables: {
        name: providerByUser,
      },
    })
      .then((response) => {
        const { createProvider: providerCreated } = response.data;
        refetch({
          search: ""
        }).then(() => {
          updateField(fieldName, [{ 
            id: providerCreated.provider.id,
            value: providerCreated.provider.id,
            label: providerCreated.provider.name
          }]);
        });
        
        handlerCreateProvider();
      })
      .catch((error) => {
        console.error("Error creating provider:", error);
      });
  }

  const handlerRejectProvider = (e) => {
    handlerCreateProvider();
    refetch({
      search: ""
    });
  }

  const handleChangeProviderByUser = (e) => {
    if (e.target.value) {
      setErrorMessage(false);
      setProviderByUser(e.target.value);
    } else {
      setProviderByUser("");
      setErrorMessage(true);
    }
  }

  useEffect(() => {
    setProviderByUser(providerName);
  }, [providerName]);

  return (
    <Modal
      size="md"
      centered
      isOpen={showCreateProviderModal}
      toggle={handlerCreateProvider}
      className="p-4 rounded"
    >
      <ModalBody>
        <h4 className="font-weight-bold mb-3">
          <FormattedMessage
            id="ProjectStepForm.step2.modal.createProvider.title"
            defaultMessage="Nuevo Proveedor"
          />
        </h4>
        <div>
          <label htmlFor="providerByUser">
            <FormattedMessage
              id="ProjectStepForm.step2.modal.createProvider.descripion"
              defaultMessage="Ingresa el nombre del nuevo proveedor:"
            />
          </label>
          <input
            name="providerByUser"
            className="form-control"
            value={providerByUser}
            onChange={(e) => handleChangeProviderByUser(e)}
            type="text"
          />
          {errorMessage && (
            <span className="text-danger">
              <FormattedMessage
                id="Validators.required"
                defaultMessage="El campo es requerido"
              />
            </span>
          )}
        </div>
        <div className="create-provider-modal__container d-flex mt-4 justify-content-end">
          <button
            type="button"
            className="step-0-form__submit-btn create-provider-modal__btn px-2 px-lg-3 py-2 m-0"
            onClick={createNewProvider}
            disabled={errorMessage}
          >
            <FormattedMessage
              id="ProjectStepForm.button.create"
              defaultMessage="Crear"
            />
          </button>
          <button
            type="button"
            className="step-0-form__submit-btn create-provider-modal__btn px-2 px-lg-3 py-2 m-0"
            onClick={handlerRejectProvider}
          >
            <FormattedMessage
              id="ProjectStepForm.button.cancel"
              defaultMessage="Cancelar"
            />
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default graphql(createProviderMutation, { name: "createProvider" })(CreateProviderModal);
